import { ExternalProjectRecordType } from 'projects/enums';
import { IProjectAutocomplete } from 'projects/types';

type TExternalProjectRow = Pick<
  IProjectAutocomplete,
  'externalProgramNumber' | 'externalProjectNumber' | 'externalRecordType'
>;

interface IExternalProjectNumbers {
  projectNumber: string | null;
  programNumber: string | null;
}

interface IExternalRecord {
  programNumber?: string | null;
  projectNumber?: string | null;
  recordType?: string | null;
}

const KNOWN_RECORD_TYPES: string[] = Object.values(ExternalProjectRecordType);

// Mirrors the BE: a known record type always wins; a missing/unknown one is read from the numbers
// (a program number without a project number ⇒ program, anything else ⇒ project).
export const isExternalProgram = ({
  programNumber,
  projectNumber,
  recordType,
}: IExternalRecord): boolean => {
  if (recordType && KNOWN_RECORD_TYPES.includes(recordType)) {
    return recordType === ExternalProjectRecordType.PROGRAM;
  }

  return !!programNumber && !projectNumber;
};

// A Program record carries no project number of its own; manual projects have no external numbers.
export const getExternalProjectNumbers = (row: TExternalProjectRow): IExternalProjectNumbers => {
  const isProgram = isExternalProgram({
    programNumber: row?.externalProgramNumber,
    projectNumber: row?.externalProjectNumber,
    recordType: row?.externalRecordType,
  });

  return {
    projectNumber: (!isProgram && row?.externalProjectNumber) || null,
    programNumber: row?.externalProgramNumber || null,
  };
};
